// extracted by mini-css-extract-plugin
export default {"theme-container":"ButtonSocialComponent_theme-container__9jYjU","button":"ButtonSocialComponent_button__HCd3J"};